// extracted by mini-css-extract-plugin
export default {"productDescription":"taa-z","featuredDescription":"uaa-z","description":"vaa-z","more":"waa-z","descriptionSku":"xaa-z"};